<template>
  <div class="step-profile">
    <form class="form" @invalid.capture.prevent="handleInvalid" @submit.prevent="handleSubmit" @change="handleChange">
      <fieldset class="fieldset">
        <legend class="legend">Create a Profile</legend>

        <div class="form__row">
          <div class="form__column">
            <Input id="first-name"
              label="First Name"
              v-model="form.firstName"
              errorCode="UserFirstNameInvalid"
              autocomplete="given-name"
              :error="formErrors['first-name']"
              required
              aria-required="true"/>
          </div>
          <div class="form__column">
            <Input id="last-name"
              label="Last Name"
              v-model="form.lastName"
              errorCode="UserLastNameInvalid"
              autocomplete="family-name"
              :error="formErrors['last-name']"
              required
              aria-required="true"/>
          </div>
        </div>

        <Phone
          id="phone"
          label="Phone Number"
          v-if="!enableSms"
          required
          v-model="form.phone"
          :error="formErrors.phone"
          errorCode="UserPhoneNumberInvalid"
          aria-required="true" />

      </fieldset>
      <div class="navigation-buttons">
        <input type="submit" class="button button--submit" :disabled="!isFilled" value="Continue">
        <PreviousStepButton />
      </div>
    </form>
  </div>
</template>
<script>
import Input from '../components/Input.vue';
import Phone from '../components/Phone.vue';
import PreviousStepButton from '../components/PreviousStepButton.vue';

export default {
  components: { Input, Phone, PreviousStepButton },
  data() {
    const { user } = this.$store.state;
    return {
      showPassword: false,
      form: {
        firstName: user.firstName,
        lastName: user.lastName,
        phone: user.phone,
      },
      formErrors: {},
    };
  },
  computed: {
    registration() {
      return this.$store.state.registration;
    },
    passType() {
      return this.$store.getters.passType;
    },
    isFilled() {
      return this.form.firstName !== ''
        && this.form.lastName !== ''
        && this.form.phone !== '';
    },
    enableSms() {
      return this.$store.state.enableSms;
    },
  },
  methods: {
    handleInvalid(e) {
      this.formErrors = {
        ...this.formErrors,
        [e.target.name]: e.target.validationMessage,
      };
    },
    handleChange(e) {
      this.formErrors = {
        ...this.formErrors,
        [e.target.name]: '',
      };
    },
    async handleSubmit() {
      this.$store.dispatch('updateUser', this.form);
      this.$router.push({ name: this.$store.getters.nextStep(this.$route.name) });
    },
  },
};
</script>
